/**
 * Circle unit abbreviations
 */
enum CircleUnit {
	RADIANS = 'rad',
	DEGREES = 'deg'
}

export default CircleUnit;